import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CustomerContext = createContext();

export const useCustomer = () => {
  const context = useContext(CustomerContext);
  if (!context) {
    throw new Error("useCustomer must be used within a CustomerProvider");
  }
  return context;
};

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem("customer_token");
    if (token) {
      try {
        const response = await axios.get(`${API}/customer/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setCustomer(response.data);
      } catch (error) {
        localStorage.removeItem("customer_token");
        setCustomer(null);
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API}/customer/login`, { email, password });
    const { token, customer: customerData } = response.data;
    localStorage.setItem("customer_token", token);
    setCustomer(customerData);
    return customerData;
  };

  const register = async (name, email, password, phone, birthdate, accountType = "private", businessData = null, fiscalCode = null, consentPrivacy = false, consentMarketing = false, partnerCompanyId = null) => {
    const response = await axios.post(`${API}/customer/register`, { 
      name, email, password, phone, birthdate,
      fiscal_code: fiscalCode,
      consent_privacy: consentPrivacy,
      consent_marketing: consentMarketing,
      account_type: accountType,
      business_data: businessData,
      partner_company_id: partnerCompanyId
    });
    const { token, customer: customerData } = response.data;
    localStorage.setItem("customer_token", token);
    setCustomer(customerData);
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem("customer_token");
    setCustomer(null);
  };

  const refreshCustomer = async () => {
    const token = localStorage.getItem("customer_token");
    if (token) {
      try {
        const response = await axios.get(`${API}/customer/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setCustomer(response.data);
        return response.data;
      } catch (error) {
        logout();
      }
    }
    return null;
  };

  const getToken = () => {
    return localStorage.getItem("customer_token");
  };

  return (
    <CustomerContext.Provider 
      value={{ 
        customer, 
        loading, 
        login, 
        register, 
        logout, 
        refreshCustomer,
        getToken,
        isLoggedIn: !!customer 
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};
